<template>
  <div class="bg-white overflow-hidden shadow rounded-lg">
    <div class="px-4 py-5 sm:px-6">Veranstaltungsort anlegen</div>

    <div class="bg-gray-100 px-4 py-5 sm:p-6">
      <div class="grid grid-cols-1 row-gap-6 col-gap-4 sm:grid-cols-6">
        <basic-input
          class="sm:col-span-4"
          label="Name"
          v-model="details.name"
          :error="errors['name']"
        />
        <basic-input
          class="sm:col-span-4"
          label="Straße"
          v-model="details.street"
          :error="errors['street']"
        />
        <basic-input
          class="sm:col-span-3"
          label="Postleitzahl"
          v-model="details.zip_code"
          :error="errors['zip_code']"
        />
        <basic-input
          class="sm:col-span-3"
          label="Stadt"
          v-model="details.city"
          :error="errors['city']"
        />

        <div class="col-span-6 flex items-end justify-between">
          <basic-button @click="store" :loading="loading" :disabled="loading">Erstellen</basic-button>
          <button @click="$emit('cancelled')" class="ml-4 underline text-sm">Abbrechen</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import BasicInput from "@/components/basic/Input";
import BasicButton from "@/components/basic/Button";
import venuesClient from "@/api/central/venues";

export default {
  components: { BasicInput, BasicButton },

  props: {
    suggestion: {
      type: String,
      required: false,
      default: ""
    }
  },

  data() {
    return {
      details: {
        name: this.suggestion,
        street: "",
        zip_code: "",
        city: ""
      },
      errors: {},
      loading: false
    };
  },
  methods: {
    store() {
      this.loading = true;

      venuesClient
        .store(this.details)
        .then(({ data }) => {
          this.$emit("input", data.data);
        })
        .catch(({ response }) => {
          this.errors = response.data.errors;
          this.$toasted.global.error();
        })
        .then(() => (this.loading = false));
    }
  }
};
</script>